import AirbrakeClient from 'airbrake-js';
import React from 'react';
import packageJson from '../../../package.json';
import './ErrorBoundary.css';

let airbrakeClient = null;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      errorId: null
    };

    if (!airbrakeClient && process.env.REACT_APP_AIRBRAKE_ENVIRONMENT) {
      airbrakeClient = new AirbrakeClient({
        projectId: process.env.REACT_APP_AIRBRAKE_ID,
        projectKey: process.env.REACT_APP_AIRBRAKE_SECRET
      });

      airbrakeClient.addFilter(function(notice) {
        notice.context.environment = process.env.REACT_APP_AIRBRAKE_ENVIRONMENT;
        notice.context.version = packageJson.version;
        notice.context.tag = process.env.REACT_APP_JENKINS_BUILD_TAG;
        return notice;
      });
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });

    if (airbrakeClient) {
      airbrakeClient
        .notify({
          error: error,
          params: { info: info }
        })
        .then(notice => {
          this.setState({ errorId: notice && notice.id });
        });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-danger error-boundary">
          An error occurred while processing your request. Please try again
          later.
          {this.state.errorId && (
            <div className="error-id">Error ID: {this.state.errorId}</div>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/containers/ErrorBoundary/index.js